import React from 'react';
import Layout from './Layout';
import HeroBanner from './HeroBanner';
import { getCourseById } from '../data/courses';
import { formatPrice, formatInstallments } from '../utils/helpers';
import './CoursePageTemplate.css';

function CoursePageTemplate({ courseId, backgroundColor }) {
  const course = getCourseById(courseId);

  if (!course) {
    return (
      <Layout title="Curso não encontrado">
        <div style={{ padding: '80px 20px', textAlign: 'center' }}>
          <h1>Curso não encontrado</h1>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title={course.name} favicon="/todos.ico">
      {/* Hero */}
      <HeroBanner
        title={course.name}
        subtitle={course.category}
        instructor={course.instructor}
        backgroundColor={backgroundColor}
        image={course.image}
      />

      {/* Content Section */}
      <section className="course-page__content">
        <div className="course-page__content-inner">
          <p className="course-page__description">{course.description}</p>
          <div className="course-page__features">
            <div className="course-page__feature">
              <span className="course-page__feature-icon" role="img" aria-label="video">&#127916;</span>
              <span className="course-page__feature-text">Videoaulas em alta qualidade com {course.instructor}</span>
            </div>
            <div className="course-page__feature">
              <span className="course-page__feature-icon" role="img" aria-label="forever">&#9854;</span>
              <span className="course-page__feature-text">Acesso vitalício a todo o conteúdo do curso</span>
            </div>
            <div className="course-page__feature">
              <span className="course-page__feature-icon" role="img" aria-label="certificate">&#127942;</span>
              <span className="course-page__feature-text">Certificado de conclusão ao finalizar o curso</span>
            </div>
            <div className="course-page__feature">
              <span className="course-page__feature-icon" role="img" aria-label="devices">&#128241;</span>
              <span className="course-page__feature-text">Acesse de qualquer dispositivo, a qualquer hora</span>
            </div>
          </div>
        </div>
      </section>

      {/* Lessons Section */}
      {course.lessons && course.lessons.length > 0 && (
        <section className="course-page__lessons">
          <h2 className="course-page__lessons-title">Conteúdo do Curso</h2>
          <div className="course-page__lessons-list">
            {course.lessons.map((lesson, index) => (
              <div key={index} className="course-page__lesson">
                <span className="course-page__lesson-number">{index + 1}</span>
                <span className="course-page__lesson-name">{lesson}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Bonuses Section */}
      {course.bonuses && course.bonuses.length > 0 && (
        <section className="course-page__bonuses">
          <h2 className="course-page__bonuses-title">Bônus Inclusos</h2>
          <div className="course-page__bonuses-list">
            {course.bonuses.map((bonus, index) => (
              <div key={index} className="course-page__bonus">
                <span className="course-page__bonus-icon" role="img" aria-label="gift">&#127873;</span>
                <span className="course-page__bonus-name">{bonus}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* CTA Section */}
      <section className="course-page__cta">
        <h2 className="course-page__cta-title">Comece agora mesmo!</h2>
        <p className="course-page__cta-price">{formatPrice(course.price)}</p>
        <p className="course-page__cta-installments">
          ou {formatInstallments(course.price)}
        </p>
        <a
          href={course.paymentUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="course-page__cta-btn"
        >
          Comprar Agora
        </a>
      </section>

      {/* Trust Section */}
      <section className="course-page__trust">
        <div className="course-page__trust-grid">
          <div className="course-page__trust-item">
            <div className="course-page__trust-icon">&#128274;</div>
            <div className="course-page__trust-title">Pagamento Seguro</div>
            <div className="course-page__trust-text">Seus dados protegidos com criptografia</div>
          </div>
          <div className="course-page__trust-item">
            <div className="course-page__trust-icon">&#9889;</div>
            <div className="course-page__trust-title">Acesso Imediato</div>
            <div className="course-page__trust-text">Comece a estudar logo após o pagamento</div>
          </div>
          <div className="course-page__trust-item">
            <div className="course-page__trust-icon">&#128176;</div>
            <div className="course-page__trust-title">7 Dias de Garantia</div>
            <div className="course-page__trust-text">Devolução integral se não ficar satisfeito</div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default CoursePageTemplate;
